import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import HiddenSeoTime, { VisibleSeoTime } from '../../../../../../../../common/seoAdUpdateTime';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            type,
            title,
            dateTime,
            subscribe = {},
            updateTime,
            publishTime,
            locale = {},
        } = content;
        const authorUrl = !subscribe.forbidJump && subscribe.authorUrl ? subscribe.authorUrl : 'javascript:;';
        const timeDir = locale.dir === 'rtl' ? 'ltr' : undefined;

        return (
            <div>
                {type !== 'short' && <h1 className={styles.topic}>{title}</h1>}
                <div className={styles.info}>
                    <div className={styles.infoboxLink}>
                        {subscribe.logo && (
                            <div className={styles.face}>
                                <a href={authorUrl}>
                                    <img className={styles.faceImg} src={subscribe.logo} alt="" />
                                    {subscribe.honorImg && <img src={subscribe.honorImg} className={styles.faceV} alt="" />}
                                </a>
                            </div>
                        )}
                        <div className={styles.textTitle}>
                            <div className={styles.sourceTitle}>
                                <div className={styles.sourceTitleText}>
                                    <a href={authorUrl}>{subscribe.catename}</a>
                                </div>
                            </div>
                            <div className={styles.timeBref}>
                                <a href={authorUrl}>
                                    <VisibleSeoTime publishTime={publishTime}>
                                        <span dir={timeDir}>{dateTime}</span>
                                    </VisibleSeoTime>
                                </a>
                                <HiddenSeoTime
                                    publishTime={publishTime}
                                    updateTime={updateTime}
                                    updateLabel={locale.updatedLabel || 'Updated'}
                                    displayFormat="iso"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.devide} />
            </div>
        );
    }
}

export default errorBoundary(Caption);
